import request from '@/utils/request';
// 获取验证码
export const getCode = (data: any) =>
  request({
    url: 'Bxgj/bxgjcode',
    method: 'POST',
    data
  });
// 登录态获取验证码
export const getUseCode = (data: any) =>
  request({
    url: 'Bxgj/usercode',
    method: 'POST',
    data
  });
// 验证图形验证码
export const checkPicVerifyCode = (data: any) =>
  request({
    url: 'Bxgj/bxgjcode',
    method: 'POST',
    data
  });
// 登录态验证图形验证码
export const checkPicVerifyUseCode = (data: any) =>
  request({
    url: 'Bxgj/usercode',
    method: 'POST',
    data
  });

// 验证验证码
export const checkVerifyCode = (data: any) =>
  request({
    url: 'Other/verifycode',
    method: 'POST',
    data
  });
  // Other/tags 获取标签
export const getTagList = (params: any) =>
  request({
    url: 'Other/tags',
    method: 'get',
    params
  });
  // Other/Fault 获取故障类型
export const getFaultList = (params: any) =>
  request({
    url: 'Other/Fault',
    method: 'get',
    params
  });
// 获取收费内容列表
export const getPriceList = (params: any) =>
  request({
    url: 'Other/Price',
    method: 'get',
    params
  });
// 获取补充进度tag
export const addedProgressTags = (params: any) =>
  request({
    url: 'Other/addedProgressTags',
    method: 'get',
    params
  });

export const getPrice = (params:any) =>
  request({
    url: 'Other/Price',
    method: 'get',
    params
  });

export const getFault = (params:any) =>
  request({
    url: 'Other/Fault',
    method: 'get',
    params
  });
export const getFaultNewList = (params:any) =>
  request({
    url: 'Other/FaultNewList',
    method: 'get',
    params
  });
